// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Hide the "Powered by" balloon
 */
 .ck.ck-balloon-panel.ck-balloon-panel_position_border-side_right.ck-powered-by-balloon{display: none!important}
`, "",{"version":3,"sources":["webpack://./src/hidePoweredBy.css"],"names":[],"mappings":"AAAA;;EAEE;CACD,uFAAuF,uBAAuB","sourcesContent":["/**\n * Hide the \"Powered by\" balloon\n */\n .ck.ck-balloon-panel.ck-balloon-panel_position_border-side_right.ck-powered-by-balloon{display: none!important}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
